/**
 * TextField
 *
 * Demos:
 *
 * - [TextField](https://ui-packages.isbuildingluma.com/ui-core/react-text-field/)
 *
 * API:
 *
 * - [TextFieldSearch API](https://ui-packages.isbuildingluma.com/ui-core/api/text-field-search/)
 * - inherits [TextField API](https://mui.com/material-ui/api/text-field/)
 *
 * Styles:
 *
 * - [Proto](https://www.figma.com/file/WJDRbOCCrGVDTsbUC3yvp8/Luma-Design-System?type=design&node-id=187-18901&t=sXXMQhhckGjEThIw-0)
 */
const MuiTextField = {
  styleOverrides: {
    root: {}
  }
};

/**
 * MuiOutlinedInput
 */
export const MuiOutlinedInput = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      '&:not(.Mui-error):not(.Mui-focused):not(:hover) .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.grey[300]
      },
      // hide legend since labels are above the input
      '& legend': {
        display: 'none'
      },
      '& .MuiOutlinedInput-notchedOutline': {
        top: 0
      }
    }),
    input: {
      // custom height (48px) for medium size TextFields
      '&:not(.MuiInputBase-inputSizeSmall)': {
        padding: '12.5px 14px'
      }
    }
  }
};

/**
 * MuiInputLabel
 */
export const MuiInputLabel = {
  defaultProps: {
    shrink: true
  },
  styleOverrides: {
    root: ({
      theme
    }) => ({
      height: 17.75,
      position: 'relative',
      transform: 'none',
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.text.secondary,
      marginBottom: theme.spacing()
    })
  }
};
export default MuiTextField;